module.exports = __webpack_public_path__ + "img/dappwallet.6a02c667.png";